<script setup>
defineProps({
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  theme: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div :class="`card card--${theme}`">
    <div v-if="image" class="card__media">
      <NuxtImg
        v-if="image?.src"
        :src="image.src"
        :alt="image.alt"
        :height="image.height"
        :width="image.width"
        class="card__image"
        loading="lazy"
      />
    </div>
    <div class="card__info">
      <p v-if="title" class="mb-0 card__title h5" v-html="title"></p>
      <div
        v-if="description"
        class="card__description body-3-regular"
        v-html="description"
      ></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.card {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
  padding: 16px;
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  @include media-breakpoint-up(sm) {
    gap: 48px;
    padding: 24px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 48);
    @include responsive-spacing(padding, 24);
  }
  &__media {
    border-radius: 4px;
    aspect-ratio: 1/1;
    overflow: hidden;
    width: 88px;
    @include media-breakpoint-up(sm) {
      width: 128px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
      @include responsive-spacing(width, 128);
    }
  }
  &__image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &__info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
  &__title {
    margin: 0;
  }
  &__description {
    padding-right: 24px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-right, 24);
    }
  }
}
</style>
